import { GET_GOAL_DETAILS } from 'store/types'

export const getGoalDetailsAction = {
  STARTED: (payload: any) => ({ type: GET_GOAL_DETAILS.STARTED, payload }),
  FULLFILLED: (payload) => ({ type: GET_GOAL_DETAILS.FULLFILLED, payload }),
  REJECTED: () => ({ type: GET_GOAL_DETAILS.REJECTED }),
}
